// Files in this directory are automatically loaded and stored in an object
// which can be deconstructed to pass them to a Vue instance

const modules = import.meta.glob(['./*.js', '!./index.js'], { eager: true })
const files = {}
const autoSetupFunctions = []

// Process all plugin JS files (index.js is excluded from the glob)
Object.entries(modules).forEach(([path, module]) => {
  const moduleName = path.split('/').pop().replace(/\.\w+$/, '')
  files[moduleName] = module.default || module

  // Look for any setup functions that start with 'setup'
  Object.entries(module).forEach(([key, value]) => {
    if (key.startsWith('setup') && typeof value === 'function') {
      autoSetupFunctions.push(value)
    }
  })
})

// Track which plugins have been set up
const appliedPlugins = new Set()

// Centralized registry to prevent duplicate setup calls
export const setupRegistry = {
  plugins: new Set(),
  components: new Set(),
}

// Import specific setup functions for explicit control
import { setupEventBus } from './eventbus'
import { setupSafeAreaInsets } from './safe-area-insets'
import { setupErrorHandler } from './error-handler'
import { setupToasts } from './toasts'
import { setupModal } from './modal'

// Export individual plugins for direct import
export { default as bus } from './eventbus'
export { default as safeAreaInsets } from './safe-area-insets'
export { default as errorHandler } from './error-handler'
export { default as toast } from './toasts'

// Main setup function that configures all plugins
export function setupPlugins(app) {
  // Setup core plugins explicitly
  const coreSetupFunctions = [
    setupEventBus,
    setupSafeAreaInsets,
    setupErrorHandler,
    setupToasts,
    setupModal,
  ]

  coreSetupFunctions.forEach(setup => {
    const setupName = setup.name || setup.toString()
    if (!appliedPlugins.has(setupName)) {
      setup(app)
      appliedPlugins.add(setupName)
    }
  })

  // Setup any additional auto-discovered plugins
  autoSetupFunctions.forEach(setup => {
    const setupName = setup.name || setup.toString()
    if (!appliedPlugins.has(setupName)) {
      setup(app)
      appliedPlugins.add(setupName)
    }
  })
}

// Export the files object for backward compatibility
export default files
